import { useIonToast } from '@ionic/react';
import { cardOutline, phonePortraitOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import ActionButton from '../../../../components/button/ActionButton';
import InputItem from '../../../../components/input/InputItem';
import { DataProvider } from '../../../../library/DataProvider';
import { SubmitPaymentPostAction } from '../../../../redux/actions/Home';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';

const Pay: React.FC = (props) => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()
    const { form_loading, resp } = useAppSelector(state => state.submitPaymentPost)

    const [form, setForm] = useState({
        mobile: { value: "", validation: { required: true }, error: "" },
        amount: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            dispatch(SubmitPaymentPostAction(form.mobile.value, form.amount.value.replace(/\D+/g, '')))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    return <form onSubmit={formSubmitHandler}>
        <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={11} ltr spaced provider={formProvider} />

        <InputItem name="amount" type="number" label="مبلغ" icon={cardOutline} maxlength={15} ltr spaced provider={formProvider} />

        <ActionButton text="ورود به صفحه پرداخت بانک" loading={form_loading} />
    </form>
}

export default Pay